<template>
    <div class="container">
        <HomeHeader />
        <ReportHeader>
            <div class="show_date">
                <ShowYear :year="year" />
                <ShowMonth :months="[month]" style="margin-left: 57px" />
            </div>
        </ReportHeader>
        <BgContainer>
            <main>
                <div class="title_row"><PageTitle title="收件人" :isBack="true" to="/" /></div>
                <div class="second_and_list">
                    <div class="second_plate">
                        <!-- <div class="all" @click="currentFavoriteId = ''">全&nbsp;&nbsp;&nbsp;&nbsp;部</div> -->
                        <div style="margin-bottom: 24px" v-if="groupList?.length">
                            <div class="li" v-for="item in groupList" :key="item.id" :class="item.id === currentGroupId ? 'active' : ''" @click="currentGroupId = item.id">
                                <h1>{{ item.name }}</h1>
                                <!-- <span>({{ item.total }})</span> -->
                                <div class="oper">
                                    <div class="btn del" @click.stop="openDG(item)">
                                        <i class="iconfont icon-jia"></i>
                                    </div>
                                    <div class="btn edit" @click.stop="openEG(item)">
                                        <i class="iconfont icon-bianji"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add_btn" @click="openAG">
                            <i class="iconfont icon-jia"></i>
                            <span>新建收件分组</span>
                        </div>
                    </div>
                    <div class="list">
                        <div class="operate_row" v-if="currentGroupId">
                            <div class="mb" @click="downloadTemplate">
                                <i class="iconfont icon-xiazai"></i>
                                <span>下载模板</span>
                            </div>
                            <el-upload action="/" :auto-upload="false" accept=".xlsx,.xls" :show-file-list="false" :on-change="handleBatch">
                                <div class="mb">
                                    <i class="iconfont icon-shangchuan"></i>
                                    <span>批量上传</span>
                                </div>
                            </el-upload>
                            <div class="add" @click="openUser('add')">
                                <i class="iconfont icon-_tianjiarenyuan"></i>
                            </div>
                        </div>
                        <ul>
                            <li v-for="item in listData" :key="item.id">
                                <div class="info">
                                    <span>{{ item.recipientName }}</span>
                                    <span>{{ item.email }}</span>
                                </div>
                                <div class="operate">
                                    <el-tooltip class="box-item" effect="dark" content="接受预警邮件" placement="top">
                                        <div class="btn" v-if="item.emailWarning === 'Y'" @click.stop="changeWarning(item, 'N')"><i class="iconfont icon-bell"></i></div>
                                        <div class="btn" v-else @click.stop="changeWarning(item, 'Y')"><i class="iconfont icon-bell-off"></i></div>
                                    </el-tooltip>
                                    <div class="btn" @click.stop="openUser('edit', item)"><i class="iconfont icon-bianji"></i></div>
                                    <div class="btn" @click.stop="openDel(item)"><i class="iconfont icon-shanchu"></i></div>
                                </div>
                            </li>
                        </ul>
                        <div class="page_box" v-if="listData.length">
                            <el-pagination small background layout="prev, pager, next" :total="total" class="pagination" v-model:current-page="query.pageNum" :page-size="query.pageSize" />
                        </div>
                        <el-empty description="暂无数据" v-if="!listData.length" />
                    </div>
                </div>
            </main>
        </BgContainer>
    </div>
    <!-- 新增组 -->
    <AddGroupDialog :show="showAG" @close="closeAG" @success="getGroupList" />
    <!-- 编辑组 -->
    <EditGroupDialog :show="showEG" :row="rowEG" @close="closeEG" @success="getGroupList" />
    <!-- 删除组 -->
    <DelGroupDialog :show="showDG" :row="rowDG" @close="closeDG" @success="getGroupList" />
    <!-- 新增/编辑收件人 -->
    <UserDialog :show="showUser" :type="typeUser" :row="rowUser" :currentGroupId="currentGroupId" :groupList="groupList" @close="closeUser" @refresh="setListData" />
    <!-- 删除收件人 -->
    <DelDialog :show="showDel" :row="rowDel" @close="closeDel" @refresh="setListData" />
</template>

<script setup>
import BgContainer from "@/components/customer-week-report/pc/BgContainer.vue";
import ReportHeader from "@/components/customer-week-report/pc/ReportHeader.vue";
import PageTitle from "@/components/customer-week-report/pc/PageTitle.vue";
import ShowYear from "@/components/customer-week-report/pc/ShowYear.vue";
import ShowMonth from "@/components/customer-week-report/pc/ShowMonth.vue";
import { useRouter, useRoute } from "vue-router";
import useGroup from "./useGroup";
import HomeHeader from "@/components/common/HomeHeader.vue";
import EditGroupDialog from "./edit-group-dialog/index.vue";
import useEditGroup from "./edit-group-dialog/useEditGroup";
import DelGroupDialog from "./del-group-dialog/index.vue";
import useDelGroup from "./del-group-dialog/useDelGroup";
import useList from "./useList";
import AddGroupDialog from "./add-group-dialog/index.vue";
import useAddGroup from "./add-group-dialog/useAddGroup";
import UserDialog from "./user-dialog/index.vue";
import useUser from "./user-dialog/useUser";
import DelDialog from "./del-dialog/index.vue";
import useDel from "./del-dialog/useDel";
import useBatch from "./useBatch";
import useEmailWarning from "./useEmailWarning";

const $route = useRoute();
const $router = useRouter();
const year = new Date().getFullYear();
const month = new Date().getMonth() + 1;

// 分组
const { groupList, currentGroupId, getGroupList } = useGroup({
    callback: () => {
        setListData();
    },
});

// 列表
const { query, total, listData, setListData } = useList({ currentGroupId });

// 新增组
const { show: showAG, open: openAG, close: closeAG } = useAddGroup();

// 编辑组
const { show: showEG, open: openEG, close: closeEG, row: rowEG } = useEditGroup();

// 删除组
const { show: showDG, open: openDG, close: closeDG, row: rowDG } = useDelGroup();

// 新增/编辑收件人
const { show: showUser, type: typeUser, row: rowUser, open: openUser, close: closeUser } = useUser();

// 删除人
const { show: showDel, open: openDel, close: closeDel, row: rowDel } = useDel();

// 批量操作
const { downloadTemplate, handleBatch } = useBatch({ currentGroupId, refresh: setListData });

// 修改接受预警邮件状态
const { changeWarning } = useEmailWarning();
</script>

<style lang="scss" scoped>
.container {
    background-color: #e6e6e6;
    min-height: calc(100vh - var(--home-header-height));
    padding-top: var(--home-header-height);

    .show_date {
        border-top: 1px solid var(--week-primary-color);
        position: absolute;
        top: 60px;
        right: 44px;
        padding-top: 30px;
        padding-right: 100px;
        padding-left: 10px;
        display: flex;
        align-items: center;
    }

    .small_logo {
        position: absolute;
        top: 87px;
        right: 52px;
    }

    main {
        width: 100%;
        min-height: calc(100vh - var(--week-pc-header-height));
        background-color: #f5f5f5;
        box-shadow: 0 0 20px #ccc;
        padding: 46px 80px;

        .title_row {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .second_and_list {
            display: flex;
            margin-top: 32px;

            .second_plate {
                --pr: 46px;
                width: calc(190px + var(--pr));
                padding-right: var(--pr);

                .all {
                    line-height: 34px;
                    background-color: var(--week-primary-color);
                    color: #fff;
                    font-size: 20px;
                    font-weight: bold;
                    cursor: pointer;
                    text-align: center;
                }

                .li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 20px;
                    padding-bottom: 10px;
                    padding-left: 8px;
                    position: relative;
                    cursor: pointer;

                    &::after {
                        display: block;
                        content: "";
                        width: 100%;
                        height: 1px;
                        background-color: #cbcbcb;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                    }

                    h1 {
                        font-weight: 400;
                        color: #818181;
                        font-size: 16px;
                    }

                    span {
                        color: #818181;
                        font-size: 14px;
                    }

                    &.active {
                        h1,
                        span {
                            color: #000;
                            font-weight: bold;
                        }

                        &::after {
                            height: 3px;
                            background-color: var(--week-primary-color);
                        }
                    }
                    .oper {
                        position: absolute;
                        display: none;
                        top: 24px;
                        left: -42px;
                        .btn {
                            display: flex;
                            width: 16px;
                            height: 16px;
                            background-color: #e6e6e6;
                            border-radius: 2px;
                            cursor: pointer;
                            align-items: center;
                            justify-content: center;
                            &:first-child {
                                margin-right: 10px;
                            }
                            .iconfont {
                                font-size: 12px;
                                color: #979797;
                            }
                            &.del {
                                .iconfont {
                                    transform: rotate(45deg);
                                }
                            }
                            &.edit {
                                background-color: #f4e8e2;
                                .iconfont {
                                    color: var(--primary-color);
                                }
                            }
                        }
                    }
                    &:hover {
                        .oper {
                            display: flex;
                        }
                    }
                }
                .add_btn {
                    height: 40px;
                    border-radius: 2px;
                    background-color: #f5f5f5;
                    border: 1px solid #ff5a00;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    .iconfont {
                        color: #979797;
                        font-size: 22px;
                    }
                    span {
                        color: var(--primary-color);
                        padding-left: 9px;
                    }
                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
        }

        .list {
            min-height: 800px;
            background-color: #fff;
            flex: 1;
            box-shadow: 2.7px 7.5px 8.19px 0.81px rgba(0, 0, 0, 0.06);
            padding-bottom: 33px;
            .operate_row {
                height: 50px;
                border-bottom: 1px solid var(--primary-color);
                display: flex;
                justify-content: flex-end;
                align-items: center;
                padding: 0 20px;
                .mb {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    margin-right: 15px;
                    .iconfont {
                        color: var(--primary-color);
                        margin-right: 4px;
                    }
                    span {
                        color: var(--primary-color);
                    }
                }
                .add {
                    width: 32px;
                    height: 32px;
                    background-color: var(--primary-color);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    .iconfont {
                        color: #fff;
                    }
                }
            }

            ul {
                padding-bottom: 50px;

                li {
                    padding: 20px;
                    border-bottom: 1px solid #cecece;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .info {
                        width: 70%;
                        display: flex;
                        span {
                            width: 50%;
                        }
                    }

                    .operate {
                        display: flex;
                        .btn {
                            width: 18px;
                            height: 18px;
                            cursor: pointer;
                            margin-left: 15px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .iconfont {
                                font-size: 18px;
                                color: #333;
                                &.icon-bell {
                                    color: var(--primary-color);
                                }
                            }
                        }
                    }

                    &:hover {
                        h1 {
                            text-decoration: underline;
                        }
                    }
                }
            }

            .page_box {
                display: flex;
                align-items: center;
                justify-content: center;

                :deep(.el-pagination .el-pager li) {
                    border-radius: 50%;
                    background-color: #cbcbcb;
                    color: #fff;
                    margin: 0 5px;
                }

                // 上下一页样式修改
                :deep(.el-pagination .btn-prev),
                :deep(.el-pagination .btn-next) {
                    background-color: #cbcbcb;
                    color: #fff;
                }

                // 上下一页不可点时，hover字体颜色修改
                :deep(.el-pagination .btn-prev:not(:disabled):hover),
                :deep(.el-pagination .btn-next:not(:disabled):hover) {
                    color: var(--week-primary-color);
                }

                :deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
                    background-color: var(--week-primary-color);
                }

                :deep(.el-pagination.is-background .el-pager li:not(.active):hover) {
                    color: var(--week-primary-color);
                }

                :deep(.btn-quicknext) {
                    display: inline-flex;
                    align-items: center;
                }
            }
        }
    }
}
</style>
